import { render, staticRenderFns } from "./ContextMenuButton.vue?vue&type=template&id=8ebfbd44"
import script from "./ContextMenuButton.vue?vue&type=script&lang=ts"
export * from "./ContextMenuButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports